import React from 'react';
import {
  DuperbrowseStream,
  DuperbrowseItemId,
  DuperbrowseSimpleStream,
  DuperbrowseLoadableStream,
} from '../redux/types';

export interface DuperbrowseStreamContextProps {
  stream:
    | DuperbrowseStream
    | DuperbrowseSimpleStream
    | DuperbrowseLoadableStream;
  loadDuperbrowse: (
    itemId: DuperbrowseItemId,
    stream: DuperbrowseStream
  ) => void;
  lastViewedItem?: {
    streamId: string;
    itemId: DuperbrowseItemId;
  };
  children?: React.ReactNode | undefined;
}

// duperbrowse context, for internal use only
export const DuperbrowseStreamContext =
  React.createContext<DuperbrowseStreamContextProps>({
    stream: {
      items: [],
      streamId: '',
    } as DuperbrowseSimpleStream,
    loadDuperbrowse: () => null,
  });
DuperbrowseStreamContext.displayName = 'DuperbrowseStreamContext';
